import { ExpeditionsActionTypes } from "./constants";

const INIT_STATE = {
  list: [],
  total: 0,
  one: null,
  loading: false,
};

interface ExpeditionCreate {
  country: string;
  comment: string;
  description: string;
  expeditionDate: Date;
  from: any;
  mode: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  transporterName: string;
  transporterPhone: string;
  weight: number;
  damaged?: number;
}

interface ExpeditionsData {
  items?: any[];
  total?: number;
}

interface GetExpeditionsData {
  id: string;
}

interface ExpeditionsActionType {
  type:
    | ExpeditionsActionTypes.GET_LIST_EXPEDITIONS
    | ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_ERROR
    | ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_SUCCESS
    | ExpeditionsActionTypes.CREATE_EXPEDITION
    | ExpeditionsActionTypes.CREATE_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.CREATE_EXPEDITION_ERROR
    | ExpeditionsActionTypes.GET_EXPEDITION
    | ExpeditionsActionTypes.GET_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.GET_EXPEDITION_ERROR
    | ExpeditionsActionTypes.UPDATE_EXPEDITION
    | ExpeditionsActionTypes.UPDATE_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.UPDATE_EXPEDITION_ERROR
    | ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION
    | ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_ERROR
    | ExpeditionsActionTypes.DELETE_EXPEDITION
    | ExpeditionsActionTypes.DELETE_EXPEDITION_SUCCESS
    | ExpeditionsActionTypes.DELETE_EXPEDITION_ERROR;
  payload: {
    actionType?: string;
    data?: ExpeditionsData;
    createData?: ExpeditionCreate;
    getExpedition?: GetExpeditionsData;
    error?: string;
    expeditionCreateError?: string;
    updated: false;
    refreshList: false;
  };
}

interface State {
  list?: any[];
  total?: number;
  one?: any;
  loading?: boolean;
  value?: boolean;
}

const Expeditions = (
  state: State = INIT_STATE,
  action: ExpeditionsActionType
): any => {
  switch (action.type) {
    case ExpeditionsActionTypes.GET_EXPEDITION:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        expeditionCreateError: "",
        total: 0,
        updated: false,
      };
    case ExpeditionsActionTypes.GET_EXPEDITION_SUCCESS:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.GET_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            expeditionCreateError: "",
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.GET_EXPEDITION_ERROR:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.GET_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            expeditionCreateError: action.payload.error,
            updated: false,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.CREATE_EXPEDITION:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        expeditionCreateError: "",
        total: 0,
      };
    case ExpeditionsActionTypes.CREATE_EXPEDITION_SUCCESS:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.CREATE_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            expeditionCreateError: "",
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.CREATE_EXPEDITION_ERROR:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.CREATE_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            expeditionCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.UPDATE_EXPEDITION:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        expeditionCreateError: "",
        total: 0,
      };
    case ExpeditionsActionTypes.UPDATE_EXPEDITION_SUCCESS:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.UPDATE_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            expeditionCreateError: "",
            updated: true,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.UPDATE_EXPEDITION_ERROR:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.UPDATE_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            expeditionCreateError: action.payload.error,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION:
      return {
        ...state,
        list: [],
        one: null,
        loading: true,
        error: "",
        expeditionCreateError: "",
        total: 0,
        refreshList: false,
      };
    case ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_SUCCESS:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: action.payload.data,
            error: "",
            expeditionCreateError: "",
            updated: true,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION_ERROR:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.UPDATE_STATUS_EXPEDITION: {
          return {
            ...state,
            list: [],
            loading: false,
            total: 0,
            one: null,
            error: action.payload.error,
            expeditionCreateError: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_SUCCESS:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.GET_LIST_EXPEDITIONS: {
          return {
            ...state,
            list: action.payload.data.items,
            loading: false,
            total: action.payload.data.total,
            one: null,
            error: "",
            expeditionCreateError: "",
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.GET_LIST_EXPEDITIONS_ERROR:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.GET_LIST_EXPEDITIONS: {
          // Voir Orders : on garde list/total pour ne pas vider l'écran sur
          // un 401 pendant refresh token / blip réseau.
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            updated: false,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.GET_LIST_EXPEDITIONS:
      return {
        ...state,
        loading: true,
        one: null,
        error: "",
        expeditionCreateError: "",
        updated: false,
        refreshList: false,
      };
    case ExpeditionsActionTypes.DELETE_EXPEDITION:
      return {
        ...state,
        refreshList: false,
      };
    case ExpeditionsActionTypes.DELETE_EXPEDITION_SUCCESS:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.DELETE_EXPEDITION: {
          return {
            ...state,
            refreshList: true,
          };
        }
        default:
          return { ...state };
      }

    case ExpeditionsActionTypes.DELETE_EXPEDITION_ERROR:
      switch (action.payload.actionType) {
        case ExpeditionsActionTypes.DELETE_EXPEDITION: {
          return {
            ...state,
            error: action.payload.error,
            refreshList: false,
          };
        }
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Expeditions;
